import Network from '../../utils/Network';
import {Urls} from '../../utils/Constants';
import { createAsyncThunk } from "@reduxjs/toolkit";

// const loginUser = createAsyncThunk(Urls.baseUrl+'/login',async(postdata)=>{
//     try{
//             let postData = postdata;
//             const response = await Network.post(Urls.baseUrl+'/login'+postData,null);            
//             if(response?.data?.status === "success"){                
//                 const result = receiveLoginResponse(response);
//                 const data = result.data;
//                 return data;
//             }else{
//                 return receiveErrorResponse(response.data);
//             }
//         } catch (err) {            
//             console.log('error',err);
//         }
    
// })
const userDetail = createAsyncThunk(Urls.baseUrlPostLogin+'/user-detail',async(postdata)=>{
    try{
            let postData = postdata;
            const response = await Network.post(Urls.baseUrlPostLogin+'/user-detail',postData);            
            if(response?.data?.status === "success"){                
                const result = receiveUserDetailResponse(response);
                const data = result.data;
                return data;
            }else{
                return receiveErrorResponse(response.data);
            }
        } catch (err) {            
            console.log('error',err);
        }
    
})
// const otpVerifyUser = createAsyncThunk(Urls.baseUrl+'/login/validate',async(postdata)=>{
//     try{
//             let postData = postdata;            
//             const response = await Network.post(Urls.baseUrl+'/login/validate',postData);
//             if(response?.data?.status === "success"){
//                 const result = receiveOtpVerifyResponse(response);
//                 const data = result.data;            
//                 return data;
//             }else{
//                 return receiveErrorResponse(response.data);
//             }
//         } catch (err) {
//             console.log('error',err);
//         }
    
// })
// Define an async logout action using createAsyncThunk
const logoutUser = createAsyncThunk('auth/asyncLogout', async () => {
    // await new Promise((resolve) => setTimeout(resolve, 1000));
    const data = [];
    return setLogoutResponse(data);
});

function setLogoutResponse(data){
    return {
      type: 'LOGOUT',
      ...data
    };
}           
// function receiveLoginResponse(data){
//     return {
//         type: 'login',
//         ...data
//     }
   
// }
function receiveUserDetailResponse(data){
    return {
        type: 'userDetail',
        ...data
    }
   
}
// function receiveOtpVerifyResponse(data){
//     return {
//         type: 'otpverify',
//         ...data
//     }
   
// }
function receiveErrorResponse(data){
    return {
        type: 'apiError',
        ...data
    }
}

export {logoutUser,userDetail}